export function guideLink(brand) {
  return brand.guides?.length ? [{ label: "Guides", href: "/guides/" }] : [];
}

// Homepage anchors scroll in place on the homepage and navigate elsewhere.
export function goToNavHref(href) {
  if (href.startsWith("/#")) {
    const hash = href.slice(2);
    if (window.location.pathname === "/" || window.location.pathname === "/index.html") {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${hash}`;
    }
  } else {
    window.location.href = href;
  }
}
